"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ranco": {
    "dc487a9d": [{
      "hkey": "ea72ee4a",
      "slug": "ranco",
      "name": "Ranco",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-giulia": [{
      "hkey": "ea72ee4a",
      "slug": "ranco",
      "name": "Ranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "85f496a2": [{
      "hkey": "ea72ee4a",
      "slug": "ranco",
      "name": "Ranco",
      "primary": true,
      "skipSearch": false
    }],
    "gerbietto": [{
      "hkey": "ea72ee4a",
      "slug": "ranco",
      "name": "Ranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3f1acd1b": [{
      "hkey": "ea72ee4a",
      "slug": "ranco",
      "name": "Ranco",
      "primary": true,
      "skipSearch": false
    }],
    "le-cascine": [{
      "hkey": "ea72ee4a",
      "slug": "ranco",
      "name": "Ranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "32606e38": [{
      "hkey": "ea72ee4a",
      "slug": "ranco",
      "name": "Ranco",
      "primary": true,
      "skipSearch": false
    }],
    "sass-cavalaasc": [{
      "hkey": "ea72ee4a",
      "slug": "ranco",
      "name": "Ranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;